// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.breadcrumb-item + .font-xl.breadcrumb-item::before {\n  color: rgb(140, 195, 38);\n  content: '>>';\n  padding: 0px 10px;\n}\n", ""]);
// Exports
module.exports = exports;
